import React from "react";

import { KPIContext } from "../contexts/kpi";

export const useKPI = () => {
    return React.useContext(KPIContext);
}